import React from "react";
import styled from "styled-components";

const FooterSection = styled.div`
  background-image: url(https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/footer_wave.svg);
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 250px;
  position: relative;

div{
  display:flex;
  flex-direction:column;
  position: absolute;
  bottom: 3rem;
}

  span {
   margin-top:10px;
    color: #fff;

    a {
      text-decoration: underline;
    }
  }
`;
function Footer() {
  return (
    <FooterSection>
      <div className="Container">
        <span>
          Modified with 💙 by{" "}
          <a
            href="https://github.com/avishmonga"
            target="_blank"
            rel="noopener noreferrer"
          >
            Avish Kumar
          </a>{" "}
        </span>
        <span>
          Coded  by{" "}
          <a
            href="https://github.com/gurupawar"
            target="_blank"
            rel="noopener noreferrer"
          >
            @gurupawar
          </a>{" "}
        </span>
      </div>
    </FooterSection>
  );
}

export default Footer;
